<template>
  <el-dialog
      title="拆分数量"
      :visible.sync="dialogVisible"
      width="500px"
      @close="handleClose">
    <div>
      <el-form label-width="100px">
        <el-form-item label="物料编号">
          <span>{{item.materialNo}}</span>
        </el-form-item>
        <el-form-item label="物料名称">
          <span>{{item.materialName}}</span>
        </el-form-item>
        <el-form-item label="当前数量">
          <span>{{currentQuantity}}</span>
        </el-form-item>
        <el-form-item label="拆分明细">
          <el-table :data="splitItems" border style="width: 100%; margin-bottom: 10px;">
            <el-table-column label="序号" width="60" type="index"/>
            <el-table-column label="数量">
              <template slot-scope="scope">
                <el-input-number
                    v-model="scope.row.quantity"
                    :min="1"
                    style="width: 120px;"
                />
              </template>
            </el-table-column>
            <el-table-column v-if="splitItems.length > 1" label="操作" width="80">
              <template slot-scope="scope">
                <el-button
                    type="danger"
                    size="mini"
                    @click="removeItem(scope.$index)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
          <el-button
              type="primary"
              size="small"
              style="margin-top: 10px;"
              @click="addItem">
            + 添加拆分项
          </el-button>
          <div class="total-info" style="margin-top: 10px; font-weight: bold;">
            已拆分数量: {{totalSplitQuantity}} / {{currentQuantity}}
            <span v-if="totalSplitQuantity !== currentQuantity" style="color: red; margin-left: 10px;">
              请拆分完所有数量
            </span>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button
          type="primary"
          :disabled="totalSplitQuantity !== currentQuantity"
          @click="handleConfirm">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  export default {
    name: "SplitQuantityDialog",
    props: {
      // 控制弹窗显示
      visible: {
        type: Boolean,
        default: false,
      },
      // 当前需要拆分的明细
      item: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        splitItems: [
          { quantity: 0 },
        ],
      };
    },
    computed: {
      dialogVisible: {
        get() {
          return this.visible;
        },
        set(val) {
          this.$emit("update:visible", val);
        },
      },
      currentQuantity() {
        return this.item.quantity;
      },
      totalSplitQuantity() {
        return this.splitItems.reduce((sum, item) => sum + item.quantity, 0);
      },
    },
    watch: {
      visible(newVal) {
        if (newVal) {
          // 弹窗打开时初始化
          this.initSplitItems();
        }
      },
    },
    methods: {
      // 初始化拆分项
      initSplitItems() {
        this.splitItems = [
          { quantity: this.item.quantity || 0 },
        ];
      },
      // 添加拆分项
      addItem() {
        this.splitItems.push({ quantity: 1 });
      },
      // 删除拆分项
      removeItem(index) {
        this.splitItems.splice(index, 1);
      },
      // 关闭弹窗
      handleClose() {
        this.dialogVisible = false;
        this.$emit("close");
      },
      // 确认拆分
      handleConfirm() {
        if (this.totalSplitQuantity !== this.currentQuantity) {
          this.$message.error("请拆分完所有数量");
          return;
        }

        // 过滤掉数量为0的项
        const validItems = this.splitItems.filter(item => item.quantity > 0);
        this.$emit("confirm", validItems.map(item => item.quantity));
        this.handleClose();
      },
    },
  };
</script>

<style scoped>
.split-list {
  max-height: 300px;
  overflow-y: auto;
}
.split-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
}
.total-info {
  color: #606266;
}
</style>
